<div class="allocations-grid">
  <div *ngFor="let item of labels; let i = index" class="month-title" [ngClass]="{'active': item.id === active}">
    <div class="calendar-label">
      <span class="label-month">{{ item.month }}</span>
      <span *ngIf="!isOneFullYear" class="label-year">{{ item.year }}</span>
    </div>
  </div>
</div>
